import { render, staticRenderFns } from "./MedicalHistory.vue?vue&type=template&id=30b1be6c&"
import script from "./MedicalHistory.vue?vue&type=script&lang=ts&"
export * from "./MedicalHistory.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('30b1be6c')) {
      api.createRecord('30b1be6c', component.options)
    } else {
      api.reload('30b1be6c', component.options)
    }
    module.hot.accept("./MedicalHistory.vue?vue&type=template&id=30b1be6c&", function () {
      api.rerender('30b1be6c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/data-entry/views/admission/MedicalHistory.vue"
export default component.exports